import gql from 'graphql-tag';
import {flowRight as compose} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from 'react-apollo';
import {Col, Container, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import Input from 'reactstrap/lib/Input';
import styled from 'styled-components';
import config from '../../../config/app';
import Error from '../../../common/components/Error/Error';
import Image from '../../../common/components/Image';
import MandatoryInput from '../../../common/components/layout/MandatoryInput';
import PopIn from '../../../common/components/PopIn';
import SelectBrand from '../../../common/components/SelectBrand';
import SelectTags from '../../../common/components/SelectTags';
import {
  CancelButton,
  FileDiv,
  FileInput,
  FileLabel, FileNameDiv,
  FooterRow,
  GradientCol,
  TitleButton,
} from '../../../common/components/StyledComp';
import Tooltip from '../../../common/components/Tooltip';
import {ALLOW_RECEIPT_MIME_TYPE} from '../../../common/constants';

const AttributeDiv = styled.div`
  text-transform: uppercase;
  font-family: 'Segoe UI Bold', sans-serif;
`;

const AttributeLabel = styled.label`
  text-transform: uppercase;
  font-family: 'Segoe UI Bold', sans-serif;
  display: flex;
`;

const RowMarginTop = styled(Row)`
  margin-top: 20px;
`;

const BrandThumbnailImage = styled(Image)`
  max-height: 80px;
`;

const CancelButtonForm = styled(CancelButton)`
  margin-top: 0;
  width: auto;
`;

const InputPro = styled(Input)`
  && {
    position: relative;
    margin: 0 0 0 15px;
    width: auto;
    height: 23px;
  }
`;

export const FileBrowse = styled(FileDiv)`
 font-size:14px;
`;

const GRAPHQL_MUTATION_ADD_RECEIPT = gql`
  mutation addReceipt($receiptInput: AddReceiptInput!) {
    addReceipt(receiptInput: $receiptInput) {
      id
      createdAt
      brand {
        id
        name
        file {
          id
          token
          key
        }
      }
    }
  }
`;

const AddReceiptUser = props => {
  const {t} = props;

  const [modalVisible, setModalVisible] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [newReceipt, setNewReceipt] = useState({brandId: null, file: null, tagsIds: [], createdAt: '', isPro: false});
  const [fileName, setFileName] = useState('');
  const [brandToken, setBrandToken] = useState('');
  const [wrongFormat, setWrongFormat] = useState(false);

  const resetAddReceipt = () => {
    setModalVisible(false);
    setNewReceipt({brandId: null, file: null, tagsIds: [], createdAt: '', isPro: false});
    setFileName('');
    setSubmitted(false);
    setWrongFormat(false);
  };

  const onReceiptAdded = (NewReceiptUser, e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!wrongFormat && newReceipt.createdAt !== '' && newReceipt.brandId !== null && newReceipt.brandId > 0) {
      NewReceiptUser().then(({data}) => {
        resetAddReceipt();
      }).catch(err =>{
        console.error(err);
      });
    }
  };

  const handleSelectTagChange = (options) => {
    const newTagList = options.map(option => option.value);
    setNewReceipt({...newReceipt, tagsIds: newTagList});
  };

  const handleSelectBrandChange = (option) => {
    setNewReceipt({
      ...newReceipt,
      brandId: Number(option.value),
    });
    setBrandToken(option.token);
  };

  const onFileChange = (event) => {
    setWrongFormat(false);
    const files = event.target.files;
    if (files) {
      if (ALLOW_RECEIPT_MIME_TYPE.includes(files[0].type)) {
        setNewReceipt({...newReceipt, file: files[0]});
        setFileName(files[0].name);
      } else {
        setWrongFormat(true);
      }
    }
  };

  return (
    <Mutation
      mutation={GRAPHQL_MUTATION_ADD_RECEIPT}
      variables={{receiptInput: newReceipt}}
      refetchQueries={['ticketsList', 'userBrands']}
    >
      {(mutation, {error, loading}) => {
        return (
          <div>
            <TitleButton onClick={() => setModalVisible(true)} className="title-btn">
              {t('AddReceiptUser.title')}
            </TitleButton>

            <PopIn visible={modalVisible} setModalVisible={setModalVisible} title={t('AddReceiptUser.title')}>
              <Container>
                <form
                  onSubmit={e => {
                    onReceiptAdded(mutation, e);
                  }}
                >
                  <RowMarginTop>
                    <Col xs={12} className="brand-info">
                      <label className="brand-label">
                        <Row className="brand-info table-container">
                          <Col xs={9} className="extended-col">
                            <label>
                              <AttributeDiv className="label-name">{`${t('AddReceiptUser.brandName')} : `}</AttributeDiv>
                              <label>
                                <SelectBrand
                                  onChange={option => handleSelectBrandChange(option)}
                                  empty={submitted && newReceipt.brandId === ''}
                                />
                              </label>
                              <Tooltip show={submitted && newReceipt.brandId === null} color={'red'}>
                                {t('AddReceiptUser.requiredField')}
                              </Tooltip>
                            </label>
                          </Col>
                          <Col xs={3} className="brand-logo">
                            {(newReceipt.brandId && brandToken !== '') && (
                              <BrandThumbnailImage
                                src={config.api_file_brand + newReceipt.brandId + '?token=' + brandToken}/>
                            )}
                          </Col>
                        </Row>
                      </label>
                    </Col>
                  </RowMarginTop>
                  <RowMarginTop>
                    <Col xs={9}>
                      <AttributeDiv className="label-name">{`${t('AddReceiptUser.receipt')} : `}</AttributeDiv>
                      <FileLabel empty={newReceipt.file === null && submitted}>
                        {' '}
                        <FileNameDiv>{fileName}</FileNameDiv>
                        <FileBrowse>{t('AddReceiptUser.browse')}</FileBrowse>
                        <FileInput type="file" accept={ALLOW_RECEIPT_MIME_TYPE.join(',')} onChange={event => onFileChange(event)} required/>
                      </FileLabel>
                      <Tooltip show={newReceipt.file === null && submitted} color="red">
                        {t('AddReceiptUser.requiredField')}
                      </Tooltip>
                      <Tooltip show={wrongFormat} color="red">
                        {t('AddReceiptUser.wrongFormat')}
                      </Tooltip>
                    </Col>
                  </RowMarginTop>
                  <RowMarginTop>
                    <Col xs={9}>
                      <AttributeDiv className="label-name">{`${t('AddReceiptUser.tags')} : `}</AttributeDiv>
                      <SelectTags
                        onChange={option => handleSelectTagChange(option)}
                      />
                    </Col>
                  </RowMarginTop>
                  <RowMarginTop>
                    <MandatoryInput
                      max={moment().format('YYYY-MM-DD')}
                      name="createdAt"
                      type="date"
                      size={9}
                      title={`${t('createdAt')} : `}
                      value={newReceipt.createdAt}
                      onChange={(name, text) => {
                        setNewReceipt({...newReceipt, createdAt: text});
                      }}
                      show={submitted && newReceipt.createdAt === ''}
                    />
                  </RowMarginTop>
                  <RowMarginTop>
                    <Col xs={9}>
                      <AttributeLabel className="label-name">{`${t('AddReceiptUser.pro')} : `}
                        <InputPro
                          value={newReceipt.isPro}
                          checked={newReceipt.isPro}
                          onChange={e => {
                            setNewReceipt({...newReceipt, isPro: e.target.checked});
                          }}
                          type="checkbox"
                        />{' '}
                      </AttributeLabel>
                    </Col>
                  </RowMarginTop>
                  <FooterRow>
                    <GradientCol sm={{span: 6, offset: 3}}>
                      {error && submitted && (
                        <Error error={t('AddReceiptUser.error')}/>
                      )}
                      <div className="popin-buttons">
                        <CancelButtonForm
                          onClick={() => {
                            resetAddReceipt();
                          }}>
                          {t('cancel')}
                        </CancelButtonForm>
                        <TitleButton
                          type="submit"
                          disabled={loading}
                          onClick={() => {
                            setSubmitted(true);
                          }}
                        >
                          {t('AddReceiptUser.title')}
                        </TitleButton>
                      </div>
                    </GradientCol>
                  </FooterRow>
                </form>
              </Container>
            </PopIn>
          </div>
        );
      }}
    </Mutation>
  );
};

AddReceiptUser.propTypes = {
  t: PropTypes.func.isRequired,
};

export default compose(
  withTranslation('ticket'),
)(AddReceiptUser);
